module.exports = __webpack_public_path__ + "static/media/Rules.f51e923a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/Rules.png
// module id = 985
// module chunks = 0